(function () {


    function fixConsole(alertFallback) {
        if (typeof window.console === "undefined") {
            window.console = {}; 
        }
        if (typeof window.console.log === "undefined") {
            if (alertFallback) {
                window.console.log = function (msg) {
                    alert(msg);
                };
            }
            else {
                window.console.log = function () { };
            }
        }
        if (typeof window.console.error === "undefined") {
            if (alertFallback) {
                window.console.error = function (msg) {
                    alert(msg);
                };
            }
            else {
                window.console.error = function () { };
            }
        }
        if (typeof window.console.warn === "undefined") {
            if (alertFallback) {
                window.console.warn = function (msg) {
                    alert(msg);
                };
            }
            else {
                window.console.warn = function () { };
            }
        }
        if (typeof window.console.dir === "undefined") {
            if (alertFallback) {
                window.console.dir = function (obj) {
                    alert("DIR: " + obj);
                };
            }
            else {
                window.console.dir = function () { };
            }
        }
    }

    fixConsole(false);

    if (!Array.prototype.includes) {
        Object.defineProperty(Array.prototype, 'includes', {
            value: function (searchElement, fromIndex) {

                if (this === null) {
                    throw new TypeError('"this" is null or not defined');
                }

                var o = Object(this);

                var len = o.length >>> 0;

                if (len === 0) {
                    return false;
                }

                var n = fromIndex | 0;

                var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

                function sameValueZero(x, y) {
                    return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
                }

                while (k < len) {
                    if (sameValueZero(o[k], searchElement)) {
                        return true;
                    }
                    k++;
                }

                return false;
            }
        });
    }

    if (!String.prototype.includes) {
        String.prototype.includes = function (search, start) {
            if (typeof start !== 'number') {
                start = 0;
            }

            if (start + search.length > this.length) {
                return false;
            }
            else {
                return this.indexOf(search, start) !== -1;
            }
        };
    }

    (function () {
        'use strict';
        var _slice = Array.prototype.slice;

        try {
            _slice.call(document.documentElement);
        }
        catch (e) { 
            Array.prototype.slice = function (begin, end) {
                end = (typeof end !== 'undefined') ? end : this.length;

                if (Object.prototype.toString.call(this) === '[object Array]') {
                    return _slice.call(this, begin, end);
                }

                var i, cloned = [],
                    size, len = this.length;

                var start = begin || 0;
                start = (start >= 0) ? start : Math.max(0, len + start);

                var upTo = (typeof end == 'number') ? Math.min(end, len) : len;
                if (end < 0) {
                    upTo = len + end;
                }

                size = upTo - start;

                if (size > 0) {
                    cloned = new Array(size);
                    if (this.charAt) {
                        for (i = 0; i < size; i++) {
                            cloned[i] = this.charAt(start + i);
                        }
                    }
                    else {
                        for (i = 0; i < size; i++) {
                            cloned[i] = this[start + i];
                        }
                    }
                }

                return cloned;
            };
        }
    }());

    "document" in self && ("classList" in document.createElement("_") && (!document.createElementNS || "classList" in document.createElementNS("http://www.w3.org/2000/svg", "g")) || !function (t) { "use strict"; if ("Element" in t) { var e = "classList", n = "prototype", i = t.Element[n], s = Object, r = String[n].trim || function () { return this.replace(/^\s+|\s+$/g, "") }, o = Array[n].indexOf || function (t) { for (var e = 0, n = this.length; n > e; e++)if (e in this && this[e] === t) return e; return -1 }, a = function (t, e) { this.name = t, this.code = DOMException[t], this.message = e }, c = function (t, e) { if ("" === e) throw new a("SYNTAX_ERR", "An invalid or illegal string was specified"); if (/\s/.test(e)) throw new a("INVALID_CHARACTER_ERR", "String contains an invalid character"); return o.call(t, e) }, l = function (t) { for (var e = r.call(t.getAttribute("class") || ""), n = e ? e.split(/\s+/) : [], i = 0, s = n.length; s > i; i++)this.push(n[i]); this._updateClassName = function () { t.setAttribute("class", "" + this) } }, u = l[n] = [], h = function () { return new l(this) }; if (a[n] = Error[n], u.item = function (t) { return this[t] || null }, u.contains = function (t) { return t += "", -1 !== c(this, t) }, u.add = function () { var t, e = arguments, n = 0, i = e.length, s = !1; do t = e[n] + "", -1 === c(this, t) && (this.push(t), s = !0); while (++n < i); s && this._updateClassName() }, u.remove = function () { var t, e, n = arguments, i = 0, s = n.length, r = !1; do for (t = n[i] + "", e = c(this, t); -1 !== e;)this.splice(e, 1), r = !0, e = c(this, t); while (++i < s); r && this._updateClassName() }, u.toggle = function (t, e) { t += ""; var n = this.contains(t), i = n ? e !== !0 && "remove" : e !== !1 && "add"; return i && this[i](t), e === !0 || e === !1 ? e : !n }, u.toString = function () { return this.join(" ") }, s.defineProperty) { var f = { get: h, enumerable: !0, configurable: !0 }; try { s.defineProperty(i, e, f) } catch (g) { (void 0 === g.number || -2146823252 === g.number) && (f.enumerable = !1, s.defineProperty(i, e, f)) } } else s[n].__defineGetter__ && i.__defineGetter__(e, h) } }(self), function () { "use strict"; var t = document.createElement("_"); if (t.classList.add("c1", "c2"), !t.classList.contains("c2")) { var e = function (t) { var e = DOMTokenList.prototype[t]; DOMTokenList.prototype[t] = function (t) { var n, i = arguments.length; for (n = 0; i > n; n++)t = arguments[n], e.call(this, t) } }; e("add"), e("remove") } if (t.classList.toggle("c3", !1), t.classList.contains("c3")) { var n = DOMTokenList.prototype.toggle; DOMTokenList.prototype.toggle = function (t, e) { return 1 in arguments && !this.contains(t) == !e ? e : n.call(this, t) } } t = null }());

    (function () {
        var lastTime = 0;
        var vendors = ['ms', 'moz', 'webkit', 'o'];
        for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
            window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
            window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
        }

        if (!window.requestAnimationFrame) {
            window.requestAnimationFrame = function (callback, element) {
                var currTime = new Date().getTime();
                var timeToCall = Math.max(0, 16 - (currTime - lastTime));
                var id = window.setTimeout(function () { callback(currTime + timeToCall); },
                    timeToCall);
                lastTime = currTime + timeToCall;
                return id;
            };
        }

        if (!window.cancelAnimationFrame) {
            window.cancelAnimationFrame = function (id) {
                clearTimeout(id);
            };
        }
    }());

    if (!("nextElementSibling" in document.documentElement)) {
        Object.defineProperty(Element.prototype, "nextElementSibling", {
            get: function () {
                var e = this.nextSibling;
                while (e && 1 !== e.nodeType)
                    e = e.nextSibling;
                return e;
            }
        });
    }
    if (!("previousElementSibling" in document.documentElement)) {
        Object.defineProperty(Element.prototype, "previousElementSibling", {
            get: function () {
                var e = this.previousSibling;
                while (e && 1 !== e.nodeType)
                    e = e.previousSibling;
                return e;
            }
        });
    }

    if (!("firstElementChild" in document.documentElement)) {
        Object.defineProperty(Element.prototype, "firstElementChild", {
            get: function () {
                for (var nodes = this.children, n, i = 0, l = nodes.length; i < l; ++i)
                    if (n = nodes[i], 1 === n.nodeType) return n;
                return null;
            }
        });
    }

    if (!("lastElementChild" in document.documentElement)) {
        Object.defineProperty(Element.prototype, "lastElementChild", {
            get: function () {
                for (var nodes = this.children, n, i = nodes.length - 1; i >= 0; --i)
                    if (n = nodes[i], 1 === n.nodeType) return n;
                return null;
            }
        });
    }
    (function (global) {
        'use strict';

        var Promise, PENDING = {}, FULFILLED = {}, REJECTED = {};
        if (typeof global.Promise === 'function') {
            Promise = global.Promise;
        }
        else {
            Promise = function (callback) {
                var fulfilledHandlers = [];
                var rejectedHandlers = [];
                var state = PENDING;
                var result,
                    dispatchHandlers,
                    makeResolver,
                    fulfil,
                    reject,
                    promise;
                makeResolver = function (newState) {
                    return function (value) {
                        if (state !== PENDING) {
                            return;
                        }
                        result = value;
                        state = newState;
                        dispatchHandlers = makeDispatcher((state === FULFILLED ? fulfilledHandlers : rejectedHandlers), result);
                        wait(dispatchHandlers);
                    };
                };
                fulfil = makeResolver(FULFILLED);
                reject = makeResolver(REJECTED);
                callback(fulfil, reject);
                promise = {
                    then: function (onFulfilled, onRejected) {
                        var promise2 = new Promise(function (fulfil, reject) {
                            var processResolutionHandler = function (handler, handlers, forward) {
                                if (typeof handler === 'function') {
                                    handlers.push(function (p1result) {
                                        var x;
                                        try {
                                            x = handler(p1result);
                                            resolve(promise2, x, fulfil, reject);
                                        } catch (err) {
                                            reject(err);
                                        }
                                    });
                                } else {
                                    handlers.push(forward);
                                }
                            };
                            processResolutionHandler(onFulfilled, fulfilledHandlers, fulfil);
                            processResolutionHandler(onRejected, rejectedHandlers, reject);
                            if (state !== PENDING) {
                                wait(dispatchHandlers);
                            }

                        });
                        return promise2;
                    }
                };
                promise['catch'] = function (onRejected) {
                    return this.then(null, onRejected);
                };
                return promise;
            };
            Promise.all = function (promises) {
                return new Promise(function (fulfil, reject) {
                    var result = [], pending, i, processPromise;
                    if (!promises.length) {
                        fulfil(result);
                        return;
                    }
                    processPromise = function (i) {
                        promises[i].then(function (value) {
                            result[i] = value;

                            if (!--pending) {
                                fulfil(result);
                            }
                        }, reject);
                    };
                    pending = i = promises.length;
                    while (i--) {
                        processPromise(i);
                    }
                });
            };
            Promise.race = function (promises) {
                return new Promise(function (fulfil, reject) {
                    promises.forEach(function (promise) {
                        promise.then(fulfil, reject);
                    });
                });
            };
            Promise.resolve = function (value) {
                return new Promise(function (fulfil) {
                    fulfil(value);
                });
            };
            Promise.reject = function (reason) {
                return new Promise(function (fulfil, reject) {
                    reject(reason);
                });
            };
        }
        function wait(callback) {
            setTimeout(callback, 0);
        }
        function makeDispatcher(handlers, result) {
            return function () {
                var handler;
                while (handler = handlers.shift()) {
                    handler(result);
                }
            };
        }
        function resolve(promise, x, fulfil, reject) {
            var then;
            if (x === promise) {
                throw new TypeError('A promise\'s fulfillment handler cannot return the same promise');
            }
            if (x instanceof Promise) {
                x.then(fulfil, reject);
            }
            else if (x && (typeof x === 'object' || typeof x === 'function')) {
                try {
                    then = x.then; 
                } catch (e) {
                    reject(e); 
                    return;
                }
                if (typeof then === 'function') {
                    var called, resolvePromise, rejectPromise;
                    resolvePromise = function (y) {
                        if (called) {
                            return;
                        }
                        called = true;
                        resolve(promise, y, fulfil, reject);
                    };
                    rejectPromise = function (r) {
                        if (called) {
                            return;
                        }
                        called = true;
                        reject(r);
                    };
                    try {
                        then.call(x, resolvePromise, rejectPromise);
                    } catch (e) {
                        if (!called) { 
                            reject(e); 
                            called = true;
                            return;
                        }
                    }
                }
                else {
                    fulfil(x);
                }
            }
            else {
                fulfil(x);
            }
        }
        global.Promise = Promise;
    }(typeof window !== 'undefined' ? window : this));
    (function (funcName, baseObj) {
        funcName = funcName || "docReady";
        baseObj = baseObj || window;
        var readyList = [];
        var readyFired = false;
        var readyEventHandlersInstalled = false;
        baseObj[funcName] = function (callback, context) {
            if (typeof callback !== "function") {
                throw new TypeError("Callback for docReady(fn) must be a function");
            }
            if (readyFired) {
                setTimeout(function () { callback(context); }, 1);
                return;
            } 
            else {
                readyList.push({ fn: callback, ctx: context });
            }
            if (document.readyState === "complete") {
                setTimeout(ready, 1);
            }
            else if (!readyEventHandlersInstalled) {
                if (document.addEventListener) {
                    document.addEventListener("DOMContentLoaded", ready, false);
                    window.addEventListener("load", ready, false);
                }
                else {
                    document.attachEvent("onreadystatechange", readyStateChange);
                    window.attachEvent("onload", ready);
                }
                readyEventHandlersInstalled = true;
            }
        };
        function ready() {
            if (!readyFired) {
                readyFired = true;
                for (var i = 0; i < readyList.length; i++) {
                    readyList[i].fn.call(window, readyList[i].ctx);
                }
                readyList = [];
            }
        }
        function readyStateChange() {
            if (document.readyState === "complete") {
                ready();
            }
        }
    })("docReady", window);
}).call(this);